/**
 * @file Disclosure.
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Disclosure component.
 */
const vDisclosure = () => {
	const disclosure = document.querySelector('#disclosure');

	if (!disclosure) {
		return;
	}

	gsap.registerPlugin(ScrollToPlugin);

	const disclosureList = disclosure.querySelector('#disclosure-list');

	document.querySelectorAll('sup').forEach((s) => {
		if (disclosure.contains(s)) {
			return;
		}

		const target  = disclosureList && disclosureList.querySelector(`#disclosure-${s.innerText}`) ? `#disclosure-${s.innerText}` : '#disclosure';
		const text    = s.innerText;
		const textNew = text.replace(/(\D*)((?:\d|,)+)(\D*)/g, `$1<a href="${target}" aria-label="footnote ${text}">$2</a>$3`);
		s.innerHTML   = textNew;
	});

	/* const blockList = [
		'p',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
		'li',
		'th',
		'td',
		'span'
	];
	const pageForms = document.querySelectorAll('form');
	blockList.forEach(b => {
		const blocks = document.querySelectorAll(`main ${b}`);
		blocks.forEach(i => {
			const inForm = [...pageForms].reduce((a, c) => {
				return a + (c.contains(i) ? 1 : 0);
			}, 0);
			if (inForm) return;
			const html = i.innerHTML;
			if (html.indexOf('<a href="#disclosure">') !== -1) return;
			const htmlNew = html.replace(/(\*+)/g, '<a href="#disclosure">$1</a>');
			if (html !== htmlNew) i.innerHTML = htmlNew;
		});
	}); */

	document.querySelectorAll('[href^="#disclosure"]').forEach((a) => {
		a.addEventListener('click', (e) => {
			const target = document.querySelector(a.getAttribute('href')) || disclosure;
			e.preventDefault();
			gsap.to(window, {
				scrollTo:   target.getBoundingClientRect().top + window.pageYOffset,
				duration:   0.75,
				onComplete: () => {
					target.focus();
				},
			});
		});
	});
};

export default vDisclosure;
